// Mock data for water IoT gateways
export const mockIoTGateways = [
  {
    deviceId: "WTRGW001",
    location: "Building A, Server Room",
    status: "Healthy",
    connectedDevices: 24,
    uptimeHours: 2184,
    cpuUsage: 32,
    memoryUsage: 45,
    temperatureCelsius: 38.5,
    firmwareVersion: "v2.9.3",
    networkStatus: {
      connectivityType: "Ethernet",
      signalStrength: 95,
      dataTransferred: 1458.7,
      lastPingTime: 23
    },
    maintenanceStatus: {
      lastMaintenance: "2024-09-20",
      nextScheduled: "2026-01-20", 
      alerts: []
    }
  },
  {
    deviceId: "WTRGW002",
    location: "Building B, Utility Room",
    status: "Warning",
    connectedDevices: 18,
    uptimeHours: 1056,
    cpuUsage: 67,
    memoryUsage: 82,
    temperatureCelsius: 55.3,
    firmwareVersion: "v2.9.2",
    networkStatus: {
      connectivityType: "Cellular",
      signalStrength: 72,
      dataTransferred: 982.3,
      lastPingTime: 48
    },
    maintenanceStatus: {
      lastMaintenance: "2024-08-10",
      nextScheduled: "2026-02-10", 
      alerts: ["High temperature warning", "Memory usage high"]
    }
  },
  {
    deviceId: "WTRGW003",
    location: "Building C, Electrical Room",
    status: "Critical",
    connectedDevices: 5,
    uptimeHours: 38,
    cpuUsage: 95,
    memoryUsage: 94,
    temperatureCelsius: 68.7,
    firmwareVersion: "v2.8.5",
    networkStatus: {
      connectivityType: "WiFi",
      signalStrength: 34,
      dataTransferred: 148.2,
      lastPingTime: 235
    },
    maintenanceStatus: {
      lastMaintenance: "2024-07-15",
      nextScheduled: "2026-01-15", 
      alerts: ["Critical temperature", "Connectivity issues", "CPU overload", "Maintenance overdue"]
    }
  },
  {
    deviceId: "gw-3045",
    location: "Building F, Pump Room",
    status: "Warning",
    connectedDevices: 14,
    uptimeHours: 1189,
    cpuUsage: 52,
    memoryUsage: 69,
    temperatureCelsius: 50.5,
    firmwareVersion: "v2.9.1",
    networkStatus: {
      connectivityType: "Cellular",
      signalStrength: 66,
      dataTransferred: 798.3,
      lastPingTime: 40
    },
    maintenanceStatus: {
      lastMaintenance: "2024-07-25",
      nextScheduled: "2026-01-25", 
      alerts: ["Battery degradation detected"]
    }
  },
  {
    deviceId: "vr-2034",
    location: "Building G, Treatment Room",
    status: "Warning",
    connectedDevices: 6,
    uptimeHours: 912,
    cpuUsage: 59,
    memoryUsage: 66,
    temperatureCelsius: 48.7,
    firmwareVersion: "v2.8.9",
    networkStatus: {
      connectivityType: "WiFi",
      signalStrength: 69,
      dataTransferred: 512.9,
      lastPingTime: 35
    },
    maintenanceStatus: {
      lastMaintenance: "2024-08-12",
      nextScheduled: "2026-02-12", 
      alerts: ["Performance degradation"]
    }
  }
];
